import { classes, media, style } from "typestyle";
import colors from "../../styles/colors";
import fontSize from "../../styles/fontSize";
import mediaQueries, { upFrom } from "../../styles/mediaQueries";
import { mb3 } from "../../styles/spacing";

export const dialogStyle = style(
  {
    background: "white",
    borderRadius: "16px",
    margin: "auto",
    boxShadow: "5px 5px 20px rgba(0,0,0,0.5)",
    border: "none",
    $nest: {
      "&::backdrop": {
        background: "rgba(0,0,0,0.4)",
      },
    },
  },
  media(upFrom(mediaQueries.desktopSmall), { maxWidth: "600px" }),
);

export const infoBox = style({
  overflow: "auto",
  padding: "2rem",
});

export const infoBoxContent = style({
  flex: 1,
  height: "80vh",
  marginTop: "8px",
  paddingRight: "1rem",
  overflow: "auto",
});

export const infoText = classes(fontSize.lg);

export const addressText = classes(fontSize.lg);

export const informationText = style(mb3);

export const heading = style({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const closeButton = style({
  background: "inherit",
  border: "none",
  fontWeight: 500,
  fontSize: "20px",
  $nest: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});

export const informationBox = style({
  display: "flex",
  flex: 1,
  marginTop: "12px",
  $nest: {
    "&>div:not(:first-child)": {
      marginTop: "12px",
    },
  },
});

export const infoBoxText = classes(
  style({
    display: "flex",
    flexDirection: "column",
    fontWeight: 400,
    $nest: {
      "&>*:first-child": {
        color: colors.grey[800],
        fontWeight: 600,
        marginBottom: "2px",
        opacity: 1,
      },
    },
  }),
  fontSize.sm,
);

export const infoHeader = style({
  display: "flex",
  fontWeight: 500,
  justifyContent: "space-between",
  width: "100%",
  marginLeft: "8px",
  alignItems: "center",
});

export const info = style(
  {
    display: "flex",
    flexDirection: "column",
  },
  media(upFrom(mediaQueries.tablet), {
    flexDirection: "row",
  }),
);

export const organizerInfoBox = style({
  display: "flex",
  alignItems: "center",
  flex: 1,
  border: "1px solid rgba(229, 231, 235, 1)",
  padding: "1rem 0.75rem",
  borderRadius: 12,
  marginTop: "16px",
});

export const organizerInfoBoxText = classes(
  style({
    display: "flex",
    flexDirection: "column",
    $nest: {
      "&>*:first-child": {
        color: colors.grey[800],
        fontWeight: 600,
        opacity: 1,
      },
    },
  }),
  fontSize.xl,
);

export const organizerInfoHeader = style({
  display: "flex",
  fontWeight: 500,
  justifyContent: "space-between",
  width: "100%",
  alignItems: "center",
});

export const organizerInfo = style(
  {
    display: "flex",
    flexDirection: "column",
  },
  media(upFrom(mediaQueries.tablet), {
    flexDirection: "row",
  }),
);

export const practicalInfoButton = style({
  background: "inherit",
  width: "100%",
  display: "flex",
  flexDirection: "column",
});
export const chevron = style({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  borderRadius: 1000,
  height: "32px",
  width: "32px",
  border: "1px solid rgba(229, 231, 235, 1)",
});

export const preview = style({
  display: "flex",
  overflow: "hidden",
  "-webkit-mask-image": "linear-gradient(to bottom, black 80%, transparent 100%)",
  maskImage: "linear-gradient(to bottom, black 80%, transparent 100%)",
  maxHeight: "350px",
  marginBottom: "0.5rem",
});

export const expandButton = style({
  border: "1px solid rgba(229, 231, 235, 1)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  borderRadius: "100%",
  padding: "0.5rem",
  backgroundColor: "white",
  bottom: "-1rem",
  right: "calc(50% - 1.125rem)",
  $nest: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});
